import { useGetMeQuery, useSaveUserByIdMutation } from '../../../../store/user/user'
import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'
import React, { useMemo, useRef } from 'react'
import { $getRoot, LexicalEditor } from 'lexical'
import {
  getEditorStateFromHtml,
  getEditorTextContent,
  getEmptyEditorState,
} from '../../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/utils'
import { $generateHtmlFromNodes } from '@lexical/html'
import { LEXICAL_NODES } from '../../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/nodes'
import { RichTextToolbarPlugin } from '../../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/Plugins/RichTextToolbarPlugin/RichTextToolbarPlugin'
import { WritableLexicalEditor } from '../../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/WritableLexicalEditor/WritableLexicalEditor'
import { Button } from '../../../../components/Button/Button'

export const EmailSignature = () => {
  const accountId = useAppSelector(selectAccountId)

  const { data: currentUser } = useGetMeQuery({ accountId }, { refetchOnMountOrArgChange: true })
  const [saveUserById, { isLoading: isUserUpdating }] = useSaveUserByIdMutation()

  const editorRef = useRef<LexicalEditor>(null)

  const initialEditorState = useMemo(() => {
    if (!currentUser?.settings?.emailSignature) {
      return null
    }
    return getEditorStateFromHtml(currentUser.settings.emailSignature)
  }, [currentUser?.settings?.emailSignature])

  if (!currentUser?.settings) {
    return null
  }

  const resetToInitial = () => {
    const editor = editorRef.current
    if (!editor) {
      return
    }
    if (!initialEditorState) {
      editor.update(() => {
        const root = $getRoot()
        root.clear()
      })
    } else {
      editor.setEditorState(initialEditorState ?? getEmptyEditorState())
    }
  }

  const saveEmailSignature = async () => {
    if (!currentUser || !editorRef.current) {
      return
    }
    const editor = editorRef.current
    const isEditorEmpty = !getEditorTextContent(editor.getEditorState()).trim()
    const emailSignature = isEditorEmpty ? null : editor.getEditorState().read(() => $generateHtmlFromNodes(editor, null))
    try {
      await saveUserById({
        accountId,
        userId: currentUser.id,
        userData: { settings: { ...currentUser.settings, emailSignature } },
        keepEmptyItems: true,
      }).unwrap()
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div className='d-flex flex-column gap-3 my-5'>
      <h5>Email signature</h5>
      <WritableLexicalEditor
        ref={editorRef}
        className='p-0'
        editorContainerClassName='flex-grow-1 pt-2 px-3 pb-4'
        initialEditorState={initialEditorState}
        lexicalNodes={LEXICAL_NODES}
        header={<RichTextToolbarPlugin className='px-3 zocks-py-0.75 gap-2' />}
        footer={
          <div className='d-flex p-3'>
            <Button className='item button-small text-decoration-none' onClick={resetToInitial} variant='link' disabled={isUserUpdating}>
              <i className='bi bi-arrow-clockwise fs-6' />
              <div className='text-decoration-underline'>Reset</div>
            </Button>
          </div>
        }
      ></WritableLexicalEditor>
      <div className='d-flex gap-3'>
        <Button variant='primary' onClick={saveEmailSignature} loading={isUserUpdating}>
          Save
        </Button>
      </div>
    </div>
  )
}
